import React from 'react';

import Link from '@material-ui/core/Link';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import PropTypes from 'prop-types';

import {config} from '../../shared/config';

import styles from './index.css';

export class QuoteLink extends React.Component {
    render() {
        return (
            <Link
                className={styles.root}
                href={`${config.core}/alfa/c/enquiry-schedule(${this.props.quoteNumber},1)`}
                rel="noopener"
                target="_blank"
            >
                {this.props.quoteNumber}
                <OpenInNewIcon className={styles.icon}/>
            </Link>
        )
    }
}

QuoteLink.propTypes = {
    quoteNumber: PropTypes.string.isRequired
};
